import React from 'react'
import PropTypes from 'prop-types'

import { TitleXS, BodyM } from '../styles/Typography'
import { TextPlusImageStyled } from '../styles/components/TextPlusImageStyled'

/**
 * Block including vertically aligned text and image.
 * @param {ComponentProps} props
 * @param {String} props.title
 * @param {String} props.text
 * @param {ChildNode} props.imgComponent
 * @param {Boolean} props.isReverse
 * @param {Boolean} props.hasVideo
 * @param {String} props.className
 * @returns {FunctionComponent}
 */
const TextPlusImage = ({ title, text, imgComponent, isReverse, hasVideo, videoLink, className }) => (
  <TextPlusImageStyled $isReverse={isReverse} className={className}>
    <div className="content">
      <TitleXS>{title}</TitleXS>
      <BodyM>{text}</BodyM>
    </div>
    <div className="img">
      {hasVideo ? (
        <div className="video">
          <div className="player-wrapper">
            <iframe
              className="player"
              src={`${videoLink}?autoplay=0&mute=1`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              width="100%"
              height="100%"
            />
          </div>
        </div>
      ) : (
        imgComponent
      )}
    </div>
  </TextPlusImageStyled>
)

TextPlusImage.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  imgComponent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isReverse: PropTypes.bool,
  hasVideo: PropTypes.bool,
  videoLink: PropTypes.string,
  className: PropTypes.string,
}

export default TextPlusImage
